import { Navigate, Outlet } from "react-router-dom";
import { Stack, Box } from "@mui/material";
import SideBar from "./SideBar";
import { useTheme } from "@mui/material/styles";
import useSettings from "../../hooks/useSettings";
import { NAVBAR } from "../../config";

const isAuthenticated = true;

const DashboardLayout = () => {
  const theme = useTheme();
  const { sidebarOpen } = useSettings();

  if (!isAuthenticated) {
    localStorage.clear();
    return <Navigate to="/" />;
  }

  return (
    <Stack direction="row">
      <SideBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: `calc(100% - ${sidebarOpen ? NAVBAR.DASHBOARD_WIDTH : NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Outlet />
      </Box>
    </Stack>
  );
};

export default DashboardLayout;
